import { useFormik } from 'formik';
import SubmitButton from '../common/SubmitButton.jsx';
import ErrorMessage from '../common/ErrorMessage.jsx';
import SuccessMessage from '../common/SuccessMessage.jsx';
import LoadingSpinner from '../common/LoadingSpinner.jsx';
import useAutomations from '../../hooks/useAutomations.js';
import { bpRemovalFormFields } from '../../config/form-fields.js';
import { bpRemovalValidation } from '../../validation/admin-automation-validations.js';

/**
 * BpForm component for rendering the form to create a Pearl ticket
 * for BP Access Removal automation process.
 *
 * @component
 * @returns {JSX.Element} - The rendered BpForm component.
 */
const BpForm = () => {
    const { error, loading, isBpRemovalSuccess, runBpRemoval } =
        useAutomations();

    const formik = useFormik({
        initialValues: bpRemovalFormFields,
        validationSchema: bpRemovalValidation,
        onSubmit: async (values) => {
            await runBpRemoval(values);
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="newsc-form-container">
                    {/* SC Device Name */}
                    <label htmlFor="deviceName" className="form-label">
                        SC Device Name in Splashtop
                    </label>
                    <input
                        id="deviceName"
                        type="text"
                        className="newsc-input"
                        placeholder="e.g. SC-Laptop-123"
                        {...formik.getFieldProps('deviceName')}
                    />
                    {formik.touched.deviceName && formik.errors.deviceName ? (
                        <ErrorMessage message={formik.errors.deviceName} />
                    ) : null}

                    {/* Start Date */}
                    <label htmlFor="startDate" className="form-label">
                        Todays Date
                    </label>
                    <input
                        id="startDate"
                        type="date"
                        className="newsc-input"
                        {...formik.getFieldProps('startDate')}
                    />
                    {formik.touched.startDate && formik.errors.startDate ? (
                        <ErrorMessage message={formik.errors.startDate} />
                    ) : null}

                    {/* Removal Date */}
                    <label htmlFor="removalDate" className="form-label">
                        Date to Remove
                    </label>
                    <input
                        id="removalDate"
                        type="date"
                        className="newsc-input"
                        {...formik.getFieldProps('removalDate')}
                    />
                    {formik.touched.removalDate && formik.errors.removalDate ? (
                        <ErrorMessage message={formik.errors.removalDate} />
                    ) : null}

                    {/* Notes */}
                    <label htmlFor="notes" className="form-label">
                        Notes
                    </label>
                    <textarea
                        id="notes"
                        className="newsc-input"
                        rows="3"
                        placeholder="Any extra details..."
                        {...formik.getFieldProps('notes')}
                    />

                    <SubmitButton label="Submit" />
                </div>
            </form>

            <br />
            <br />
            {loading && <LoadingSpinner />}
            {Object.keys(formik.errors).length !== 0 &&
            Object.keys(formik.touched).length !== 0 ? (
                <ErrorMessage message="There are form errors above, please fix." />
            ) : null}
            {error && <ErrorMessage message={error.message} />}
            {isBpRemovalSuccess && (
                <SuccessMessage message="BP Access Removal Ticket created successfully!" />
            )}
        </>
    );
};

export default BpForm;
